import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { IServiceObject } from "@/shop/types/services";

import * as ServicesActions from "./actions";

export type ServicesAction = ActionType<typeof ServicesActions>;

export interface IServicesReducerState {
  services: IServiceObject[];
  hasError: boolean;
  isFetching: boolean;
}

const initialState: IServicesReducerState = {
  services: null!,
  hasError: false,
  isFetching: false
};

interface IServicesUpdate {
  services: IServiceObject[];
  hasError: boolean;
  isFetching: boolean;
}

function updateServicesState(state: IServicesReducerState, { services, hasError, isFetching }: IServicesUpdate): IServicesReducerState {
  return {
    ...state,
    ...services,
    isFetching,
    hasError
  };
}

export default function servicesReducer(state = initialState, action: ServicesAction): IServicesReducerState {
  switch (action.type) {
    case getType(ServicesActions.fetchServicesStart): {
      return updateServicesState(state, { isFetching: true, hasError: false, services: null! });
    }

    case getType(ServicesActions.fetchServicesFail): {
      return updateServicesState(state, { isFetching: false, hasError: true, services: null! });
    }

    case getType(ServicesActions.fetchServicesSuccess): {
      const { services } = action.payload;
      return updateServicesState(state, { isFetching: false, hasError: false, services });
    }

    default:
      return state;
  }
}
